import React, {useEffect} from 'react';

import {Entry} from 'contentful';

import {GaEcommerceItem, viewItemListEvent} from 'src/utils/analytics/events';
import {track} from 'src/utils/analytics/gtag';
import {variantToItems} from 'src/utils/analytics/variantToItems';
import {getImageSourceFromAsset, IProduct} from 'src/utils/contentful';
import {IProductCollectionFields} from 'src/utils/contentful/content-models/generated/contentful';

import {GridItem} from '../LinkGridLayout';
import {ProductVariantPrice} from '../ProductVariantPrice';
import {ProductLinkGridSection} from '../layout/ProductLinkGridSection';

export interface CollectionPageTemplateProps {
  collection: Entry<IProductCollectionFields>;
  products: IProduct[];
}

export const CollectionPageTemplate: React.FC<CollectionPageTemplateProps> = (
  props
) => {
  const {collection, products} = props;

  const productPreviews: GridItem[] = products.map((product) => {
    const {
      fields: {name, slug, variants},
    } = product;
    const firstVariant = variants[0];

    const backgroundImage = firstVariant.fields.images
      ? firstVariant.fields.images[0]
      : firstVariant.fields.previewImage;

    return {
      key: firstVariant.sys.id,
      title: name,
      subTitle: (
        <ProductVariantPrice variant={firstVariant} intervalFormat={'short'} />
      ),
      backgroundImageSrc: getImageSourceFromAsset(backgroundImage),
      linkTo: `/products/${slug}`,
    };
  });

  useEffect(() => {
    track(
      viewItemListEvent({
        ecommerce: {
          item_list_id: collection.sys.id,
          item_list_name: collection.fields.name,
          items: products.reduce((gaItems, product) => {
            return [...gaItems, ...variantToItems(product.fields.variants[0])];
          }, [] as GaEcommerceItem[]),
        },
      })
    );
  }, [collection, products]);

  return (
    <ProductLinkGridSection
      title={collection.fields.name}
      items={productPreviews}
    />
  );
};
